import { FeaBaseProcessService } from './fea-base-process.service';
import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import FeaUtils from '../../FeaUtils';
import { VectorResult } from '../../models/results/vector-result';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaNastranService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(vectorName:string, byNode: boolean) : Promise<any> { // TODO: correctly use parameters
    const type: string = byNode ? "NodeTop" : "ElemTop";

    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest,
      ResultType: 'Merge',
      //OutputSet: "1", // While we cannot choose the output, choose the latest
      //Vector: `ElementStressCQUAD4/${type}/PlateVonMisesStress`
      Vector: `${type}/PlateVonMisesStress`
    };

    // const request1 = {
    //   ...baseRequest,
    //   ResultType: 'Single',
    //   //OutputSet: "1", // While we cannot choose the output, choose the latest
    //   //Vector: `ElementStressCQUAD4/${type}/PlateVonMisesStress`
    //   Vector: `ElementStressCQUAD4/${type}/PlateVonMisesStress`
    // };

    // const request2 = {
    //   ...baseRequest,
    //   ResultType: 'Single',
    //   //OutputSet: "1", // While we cannot choose the output, choose the latest
    //   //Vector: `ElementStressCQUAD4/${type}/PlateVonMisesStress`
    //   Vector: `ElementStressCTRIA3/${type}/PlateVonMisesStress`
    // };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }),
      responseType: 'json' as 'json'
    };

    try {
      const resultData1 = await firstValueFrom(this.http.post(environment.API_FEA + `Nastran/GetResult`, request, options));
      const vectorResult1 = new VectorResult(resultData1);

      const csvText = await firstValueFrom(this.http.get(vectorResult1.ResultUrl, { responseType: 'text' as 'text' }));
      var valuesPerElement = FeaUtils.ExtractValuesFromCSV(csvText);

      // if (type == "ElemTop") {
      //   const resultData2 = await firstValueFrom(this.http.post(environment.API_FEA + `Nastran/GetResult`, request2, options));
      //   const vectorResult2 = new VectorResult(resultData2);

      //   const csvText2 = await firstValueFrom(this.http.get(vectorResult2.ResultUrl, { responseType: 'text' as 'text' }));
      //   var valuesPerElement2 = FeaUtils.ExtractValuesFromCSV(csvText2);
      //   valuesPerElement = this.mergeDictionaries(valuesPerElement, valuesPerElement2)
      // }

      var title = `Analysis: Nastran - Output Set: Last \nOutput Vector: ${type} PlateVonMisesStress`;
      return {
        valuesPerElement: valuesPerElement,
        title: title,
        processResult: vectorResult1
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get or parse nastran result");
      return null; // Indicate failure
    }
  }

  private mergeDictionaries(dict1: { [key: number]: number }, dict2: { [key: number]: number }): { [key: number]: number } {
    const mergedDict: { [key: number]: number } = { ...dict1 }; // Start with a copy of the first dictionary

    for (const key in dict2) {
      if (dict2.hasOwnProperty(key)) {
        mergedDict[key] = dict2[key]; // Override or add values from the second dictionary
      }
    }

    return mergedDict;
  }
}
